const paper = {
    styleOverrides: {
        root: {
            backgroundColor: "#1D1D1D"
        }
    }
};

export default paper;